export const API_ERROR = 'API_ERROR'
export const START_FETCH = 'START_FETCH'
export const STOP_FETCH = 'STOP_FETCH'
export const SET_STARTUP_LIST_DATA = 'SET_STARTUP_LIST_DATA'
export const START_FOLLOWING = 'START_FOLLOWING'
export const STOP_FOLLOWING = 'STOP_FOLLOWING'

export const START_RECENT_FETCH = 'START_RECENT_FETCH'
export const STOP_RECENT_FETCH = 'STOP_RECENT_FETCH'
export const SET_RECENT_STARTUP_LIST_DATA = 'SET_RECENT_STARTUP_LIST_DATA'
